/**
 * THIS IS AN AUTO-GENERATED FILE FROM SVGR. DO NOT MODIFY!
 *
 * File was made using the 'rushx build:icons' command.
 * To learn more see the {@link https://github.com/seequent/user-portal/blob/master/libraries/web-design-system-2/README.md#making-icons-|ReadMe}
 */
import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { createElement } from 'react';

function SvgArrowUpIcon(props: SvgIconProps) {
    return createElement(
        SvgIcon,
        { style: { width: '1em', height: '1em' }, viewBox: '0 0 24 24', ...props },
        <path
            fill="currentColor"
            fillOpacity={0.9}
            fillRule="evenodd"
            d="M11.823 11.094a.25.25 0 0 1 .354 0l3.762 3.762a.5.5 0 0 0 .707 0l.708-.707a.5.5 0 0 0 0-.707L13.06 9.15a1.5 1.5 0 0 0-2.122 0l-4.293 4.293a.5.5 0 0 0 0 .707l.708.707a.5.5 0 0 0 .707 0z"
            clipRule="evenodd"
        />,
    );
}
export default SvgArrowUpIcon;
